import { useAppSelector } from '@/redux/hooks'

export const HoffHeader = () => {
  const settings = useAppSelector(
    (store) => store.settingsApi.settings.response
  )

  return (
    <header className="sticky top-0 z-10 bg-white">
      <div className="flex w-full items-center justify-between gap-10 px-4 py-2 md:px-8 md:py-4">
        {settings.branding?.logo_url ? (
          <div className="h-auto w-48">
            <img
              src={settings.branding?.logo_url}
              alt=""
              width={200}
              height={28}
              className="h-auto w-full"
            />
          </div>
        ) : null}
        <div className="flex gap-5">
          <a href="https://thehoffbrand.com/account">
            <svg
              aria-hidden="true"
              fill="none"
              focusable="false"
              width="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M16 7.00046C16 9.22633 14.1653 11.034 11.9396 11.0005C9.74736 10.9674 8 9.193 8 7.00046C8 4.80793 9.74736 3.03354 11.9396 3.00046C14.1653 2.96687 16 4.77459 16 7.00046Z"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
              <path
                d="M1.98047 21V18C1.98047 15.7909 3.77133 14 5.98047 14H12H18.0192C20.2283 14 22.0192 15.7909 22.0192 18V21"
                stroke="currentColor"
                strokeWidth="1"
                strokeMiterlimit="10"
              ></path>
            </svg>
          </a>
          <a href="https://thehoffbrand.com/search">
            <svg
              aria-hidden="true"
              fill="none"
              focusable="false"
              width="24"
              className="header__nav-icon icon icon-search"
              viewBox="0 0 24 24"
            >
              <path
                d="M10.364 3a7.364 7.364 0 1 0 0 14.727 7.364 7.364 0 0 0 0-14.727Z"
                stroke="currentColor"
                strokeWidth="1"
                strokeMiterlimit="10"
              ></path>
              <path
                d="M15.857 15.858 21 21.001"
                stroke="currentColor"
                strokeWidth="1"
                strokeMiterlimit="10"
                strokeLinecap="round"
              ></path>
            </svg>
          </a>
          <a href="https://thehoffbrand.com/">
            <svg
              aria-hidden="true"
              fill="none"
              focusable="false"
              width="24"
              viewBox="0 0 24 24"
            >
              <path
                d="M8 12V7C8 5.93913 8.42143 4.92172 9.17157 4.17157C9.92172 3.42143 10.9391 3 12 3C13.0609 3 14.0783 3.42143 14.8284 4.17157C15.5786 4.92172 16 5.93913 16 7V12M4 21H20C21.1046 21 22 20.1046 22 19V11C22 9.89543 21.1046 9 20 9H4C2.89543 9 2 9.89543 2 11V19C2 20.1046 2.89543 21 4 21Z"
                stroke="currentColor"
                strokeWidth="1"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </a>
        </div>
      </div>
    </header>
  )
}
